import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";

import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import {primitiveType, pixelBufferType, attachmentId} from "_src/engine/constants";

import CopyShader from "_src/shaders/copy/copy";
import Camera from "_src/engine/camera";
export default class CompareMixPass extends Pass {

  constructor(attachmentsStorage) {

    super(attachmentsStorage);

    this.init();

  }

  init() {
    const camera = new Camera();
    const scene = this._addScene(camera);
    scene.clearedColor = false;

    const screenChunk = primitiveFactory.create(primitiveType.SCREEN_QUAD);

    const leftModelShader = new CopyShader({transparent: true});
    leftModelShader.enableScissorTest();
    const leftModelScreenPlane = objFactory.createDrawable(leftModelShader);
    leftModelScreenPlane.addGeometryChunk(screenChunk);

    const rightModelShader = new CopyShader({transparent: true});
    rightModelShader.enableScissorTest();
    const rightModelScreenPlane = objFactory.createDrawable(rightModelShader);
    rightModelScreenPlane.addGeometryChunk(screenChunk);

    scene.add(leftModelScreenPlane);
    scene.add(rightModelScreenPlane);
  }

  update() {
    const scene = this.getMainScene();

    const width = scene.camera.viewport[2];
    const height = scene.camera.viewport[3];

    const frameBuffer = this.initFramebuffer(width, height);
    scene.setFramebuffer(frameBuffer);

    const leftModelScreenPlane = scene.getChildren()[0];
    const rightModelScreenPlane = scene.getChildren()[1];

    leftModelScreenPlane.setTexture(this.attachmentsStorage[attachmentId.COMPARE_LEFT_TEXTURE], 0);
    rightModelScreenPlane.setTexture(this.attachmentsStorage[attachmentId.COMPARE_RIGHT_TEXTURE], 0);
  }

  initFramebuffer(width, height) {
    const usedTexture = this.attachmentsStorage[attachmentId.OUTPUT_COLOR_TEXTURE];
    const texture = usedTexture ? usedTexture : resourceManager.initBuffer(pixelBufferType.T_RGBA, { width, height });
    this.attachmentsStorage[attachmentId.OUTPUT_COLOR_TEXTURE] = texture;

    const frameBuffer = new FrameBuffer([texture], null);
    return frameBuffer;
  }

  setSplitPosition(x) {
    const scene = this.getMainScene();
    const vp = scene.camera.viewport;
    const leftModelScreenPlane = scene.getChildren()[0];
    const rightModelScreenPlane = scene.getChildren()[1];

    leftModelScreenPlane.shader.setScissor([vp[0], vp[1], x-vp[0], vp[3]]);
    rightModelScreenPlane.shader.setScissor([x, vp[1], vp[2] - (x-vp[0]), vp[3]]);
  }
}
